/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Rate_TranscriptionInputs */



/**
* | output |
* | --- |
* | "$0.10 / min" |
*
* @param {Usage_Rate_TranscriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_rate_transcription = /** @type {((inputs?: Usage_Rate_TranscriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Rate_TranscriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("0,10 $ / min")
	if (locale === "de") return /** @type {LocalizedString} */ ("0,10 $ / Minute")
	if (locale === "it") return /** @type {LocalizedString} */ ("$0,10 / min")
	if (locale === "ru") return /** @type {LocalizedString} */ ("0,10 долл. США/мин")
	if (locale === "es") return /** @type {LocalizedString} */ ("$0.10 / minuto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每分钟 0.10 美元")
	if (locale === "ja") return /** @type {LocalizedString} */ ("0.10ドル / 分")
	if (locale === "hi") return /** @type {LocalizedString} */ ("$0.10 / मिनट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("US$ 0,10 / min")
	return /** @type {LocalizedString} */ ("$0.10 / min")
});